__turbopack_context__.v({
  "card": "Galeria-module__455Yqa__card",
  "cardBody": "Galeria-module__455Yqa__cardBody",
  "cardImage": "Galeria-module__455Yqa__cardImage",
  "cardMeta": "Galeria-module__455Yqa__cardMeta",
  "cardTitle": "Galeria-module__455Yqa__cardTitle",
  "empty": "Galeria-module__455Yqa__empty",
  "footer": "Galeria-module__455Yqa__footer",
  "footerCopy": "Galeria-module__455Yqa__footerCopy",
  "footerLinks": "Galeria-module__455Yqa__footerLinks",
  "footerLogo": "Galeria-module__455Yqa__footerLogo",
  "grid": "Galeria-module__455Yqa__grid",
  "image": "Galeria-module__455Yqa__image",
  "pageHeader": "Galeria-module__455Yqa__pageHeader",
  "pageTitle": "Galeria-module__455Yqa__pageTitle",
  "site": "Galeria-module__455Yqa__site",
});
